var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.params.node.rowPinned !== 'bottom')?_c('span',{staticClass:"wrapper"},[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:(_vm.params.value),expression:"params.value",modifiers:{"bottom":true}}]},[(_vm.hasReceipt)?_c('i',{staticClass:"fas fa-camera",staticStyle:{"color":"#4A90E2"}}):_vm._e(),_vm._v("\n    "+_vm._s(_vm.params.value)+"\n  ")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-569dcf12","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_modules/Programs/Card-transactions/ReconciliationStatus.vue
// module id = Pr2y
// module chunks = 12